import React from "react";
import Game from "./src/Game";
import useUserInfo from "../../../Hooks/useUserInfo";
import { useAudio } from "../../../Providers/AudioProvider";
import { logPageView } from "../../../components/analytics";
import task from "../Task";
import "./src/fruits.css";

const FruitSlice = () => {
  const { userDetails, updateUserInfo } = useUserInfo();
  const playClick = useAudio();

  React.useEffect(() => {
    logPageView("FruitSlicePage", "Fruit Slice Game");
  }, []);

  const toogleMenu = () => {
    playClick();
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: task,
      currentComponentText: "task",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };

  return (
    <div className="game-fruitslice" style={{ pointerEvents: "fill" }}>
      <img
        onClick={toogleMenu}
        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
        className="cancel-full"
        style={{ cursor: "pointer", zIndex: "2" }}
        alt="Close"
      />
      <Game />
    </div>
  );
};

export default FruitSlice;
